module.exports = __webpack_public_path__ + "img/toNPC.ffda4d19.svg";